import React from "react";
import { NavLink } from "reactstrap";
import Header from "./../Layout/Header";
import PageTitle from "./../Pages/PageTitle";

import profile from "../../images/profile/2.png";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const { t } = useTranslation();
  const email = "miraclepaceinc@outlook.com";

  const handleCopy = () => {
    navigator.clipboard
      .writeText(email)
      .then(() => {
        alert("Email copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  return (
    <div>
      <Header />
      <PageTitle />
      <div className="accounts mb-80">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="card profile_card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h4 className="mb-2">Please contact us by following email address.</h4>
                      {/* <p className="mb-1">
                        {" "}
                        <span>
                          <i className="fa fa-phone me-2 text-primary"></i>
                        </span>{" "}
                        +1 647 888 8888
                      </p> */}
                      <p className="mb-1">
                        {" "}
                        <span>
                          <i className="fa fa-envelope me-2 text-primary"></i>
                        </span>
                        {email}
                      </p>
                      <button
                        type="button"
                        className="btn btn-success btn-block"
                        onClick={handleCopy}
                      >
                        {t("copy.email.label")}
                      </button>
                    </div>
                  </div>

                  <div className="social-icons">
                    <NavLink className="facebook text-white text-center" to="/">
                      <span>
                        <i className="fa fa-facebook"></i>
                      </span>
                    </NavLink>
                    <NavLink className="twitter text-white text-center" to="/">
                      <span>
                        <i className="fa fa-twitter"></i>
                      </span>
                    </NavLink>
                    <NavLink className="youtube text-white text-center" to="/">
                      <span>
                        <i className="fa fa-youtube"></i>
                      </span>
                    </NavLink>
                    <NavLink
                      className="googlePlus text-white text-center"
                      to="/"
                    >
                      <span>
                        <i className="fa fa-google"></i>
                      </span>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
